import PropTypes from 'prop-types';
import EverTrue from 'app';
import { useFluxStore } from '@evertrue/et-flux';
import ListController from 'apps/lists/controllers/list-controller';
import CoreSearchSource from 'apps/core-search/sources/core-search-source';
import CoreSearchStore from 'apps/core-search/stores/core-search-store';
import SegmentFiltersController from 'apps/filters/controllers/segment-filters-controller';
import FilterSource from 'apps/filters/sources/filter-source';
import FilterStore from 'apps/filters/stores/filter-store';
import { useEffect, useState } from 'react';
import listQueries, { preparedContactIdQuery } from '../queries/list-queries';
import { fetchFromGraphql } from 'entities/helpers/gqlCall';
import UrlSource from 'apps/layout/sources/url-source';
import ContactSource from 'apps/contact/sources/contact-source';

const coreSearchStoreMap = () => ({
  typeSearchConfig: CoreSearchStore.getConfig(),
});

const ListSearchController = ({ view = 'table', listId, type = 'lists' }) => {
  const [listContactIdQuery, setListContactIdQuery] = useState(null);
  const [listContactIds, setListContactIds] = useState([]);
  const { typeSearchConfig } = useFluxStore(CoreSearchStore, () => coreSearchStoreMap());

  useEffect(() => {
    // Clearing Filters on load or when view changes to "map"
    if (view === 'map' || view === 'table') {
      UrlSource.updateSegment();
      FilterSource.set();
      ContactSource.query();
    }

    //Set List type filter
    CoreSearchSource.setType(type);

    // Fetching list contact ids for the query
    const fetchListContactIds = async () => {
      const query = listQueries.getListContactIds;
      const params = { listId: listId };
      const { getListContactIds } = await fetchFromGraphql(query, params, 'getListContactIds');
      setListContactIds(getListContactIds);
      setListContactIdQuery(preparedContactIdQuery(getListContactIds));
    };
    fetchListContactIds();
  }, [listId, type, view]);

  const handleFilterChange = () => {
    CoreSearchSource.query(type, listContactIdQuery);
    let route = typeSearchConfig[type].route;
    if (type === 'lists') {
      route = `/list/${listId}`;
    }
    if (route) {
      EverTrue.UrlManager.navigate(route);
    }
  };

  const handleApplyFilters = () => {
    if (view === 'map') {
      FilterSource.fetchFilteredClusters();
    }
    handleTrack();
  };

  const handleTrack = () => {
    const filter_keys = FilterStore.getActiveFilterKeys() || [];
    if (filter_keys.length > 0) {
      EverTrue.track.set('filter_applied', {
        type: 'filter',
        params: filter_keys,
        operator: FilterStore.getOperator(),
        result_type: type === 'contacts' ? 'constituents' : type,
      });
    }
  };

  return (
    <div>
      <SegmentFiltersController
        view={view}
        onApply={handleApplyFilters}
        onChange={handleFilterChange}
        type={type}
        disabledFilters={view === 'map'}
      />
      <ListController
        listId={listId}
        view={view}
        listContactIds={listContactIds}
        listContactIdQuery={listContactIdQuery}
      />
    </div>
  );
};

ListSearchController.propTypes = {
  view: PropTypes.string,
  type: PropTypes.string,
  listId: PropTypes.any,
};

export default ListSearchController;
